/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 

$(document).ready(function() {
	// Collection page
 	filterCollection();
 	quickAddLabel();
 	quickAddToCart();
 	closeQuickAdd();

 	// Campaign list
 	campaignList();
 	$(window).resize(function(){
		campaignList();
	});

	selectAddress();

	// Search
	// clearSearch();

	
	// contact_tabs();
	accordionWithSidebar(contactAccordion);
	footerAccordion(contactAccordion);
	sideBarAccordion(contactAccordion);
	Drawer(drawers);
	sustainability_tabs();
});



function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
}

function filterCollection() {
	$('.CollectionToolbar__Item').on('click', function() {
 		var data = $(this).attr('data-tool');
 		if (typeof data !== typeof undefined && data !== false) {
 			// $('html').addClass('no-scroll');
 			$('.filter-bg, .close-filter').show();
 			$(this).siblings().removeClass('active');
 			$(this).addClass('active');
	 		$('.CollectionContent[data-tool="'+data+'"]').siblings().addClass('hidden');
	 		$('.CollectionContent[data-tool="'+data+'"]').removeClass('hidden');
	 		$('.CollectionToolbar').addClass('ShowFilter');
	 	}
 	});
 	$('.filter-bg, .close-filter').on('click', function() {
 		// $('html').removeClass('no-scroll');
		$('.filter-bg, .close-filter').hide();
		$('.CollectionToolbar__Item').removeClass('active');
 		$('.CollectionContent').addClass('hidden');
 		$('.CollectionToolbar').removeClass('ShowFilter');
 	});
 	$('button[data-action="toggle-tag"]').on('click', function() {
 		if ($(window).width() < 1008) {
 			setTimeout(function () {
			   	$('button[data-action="apply-tags"]').trigger('click');
			}, 500);
 		}
 	});
}

function quickAddLabel() {
	$('.QuickAdd__Swatch.limited-availability').hover(function() {
		$(this).closest('.ProductForm').find('.QuickAdd__Mess').text(window.languages.limitedAvailability);
	}, function() {
		$('.QuickAdd__Mess').text('');
	});

	$('.QuickAdd__Swatch.disabled').hover(function() {
		$(this).closest('.ProductForm').find('.QuickAdd__Mess').text(window.languages.outOfStock);
	}, function() {
		$('.QuickAdd__Mess').text('');
	});
}

function quickAddToCart() {
	$('.QuickAdd__Swatch.js').on('click', function(e) {
		e.preventDefault();
		document.dispatchEvent(new CustomEvent('theme:loading:start'));

		let variantId = $(this).val();
		$.ajax({
	      	url:'/cart/add.js',
	      	type: 'POST',
	      	data:{ id: variantId, quantity: 1 },
	      	dataType: 'json',
	      	success: function (result) {
	      		// Update + show cart popup
	      		// $('.QuickAddPopup__Image img').attr('src', result.image);
	      		// $('.QuickAddPopup__Title').text(result.product_title);
	      		// $('.QuickAddPopup__Variant').text(result.variant_title);
	      		// $('.QuickAddPopup__Price').text(formatMoney(result.price, window.theme.moneyFormat));
	      		// $('html').addClass('no-scroll');
	      		// $('.QuickAddPopup__Bg, .QuickAddPopup').show();

	      		// Update mini cart
	      		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
				    bubbles: true
				}));
				
	      		document.dispatchEvent(new CustomEvent('theme:loading:end'));

				const cartIcon = document.querySelector('.Header__SecondaryNav a[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
				cartIcon.click();
	      	},
	      	error: function(error) {
		        $('.QuickAdd__Mess').text(error.responseJSON.description);
	      		document.dispatchEvent(new CustomEvent('theme:loading:end'));
	      	}
	    });
	});
}

function closeQuickAdd() {
	$('.QuickAddPopup__Close, .ContinueShopping, .QuickAddPopup__Bg').on('click', function() {
		$('html').removeClass('no-scroll');
	    $('.QuickAddPopup__Bg, .QuickAddPopup').hide();
	});
}

function campaignList() {
	$('.CampaignList__Heading').hover(function(){
		let dataImg = $(this).data('img')
	    $('.CampaignList').css('background-image', 'url(' + dataImg + ')');
	    $(this).css('color', '#C4202C');
	}, function(){
	    $('.CampaignList').css('background-image', 'none');
	    $(this).css('color', '#000');
	});

	// if($('.CampaignList__Block img').length > 0) {
	// 	let windowWidth = $(window).width();
	// 	let windowHeight = $('.CampaignList').outerHeight();
	// 	if(windowWidth >= windowHeight) {
	// 		$('.CampaignList__Block img').removeClass('vertical').addClass('horizontal');
	// 	} else {
	// 		$('.CampaignList__Block img').addClass('vertical').removeClass('horizontal');
	// 	}
	// }

}

const nav = document.querySelector('.shopify-section--header');
const body = document.querySelector('body');

window.addEventListener('scroll', function() {

	const offset = window.pageYOffset;

	if (offset > 0) {
		nav.classList.add('scroll');
		body.classList.add('header-scrolling');
	} else {
		nav.classList.remove('scroll');
		body.classList.remove('header-scrolling');
	}
});

function clearSearch() {
	// $('#Search [name="q"]').on('keyup', function() {
	// 	if ($(this).val().length > 0) {
	// 		$('#Search .ClearSearch').show();
	// 	} else {
	// 		$('#Search .ClearSearch').hide();
	// 	}
	// });
	$('#Search .ClearSearch').on('click', function() {
		$('#Search [name="q"]').val('');
		$('.Search__Results').empty().attr('aria-hidden', 'true');
	});
}

// function contact_tabs(){
//     // $(".contact-tabs .tabs .tab-wrapper:nth-child(1) ").addClass("active");
//     $(".contact-tabs .tabs .tab-wrapper .tab-top ").click(function(){
//     	if($(this).parents(".tab-wrapper").hasClass("active")){
//           $(this).parents(".tab-wrapper").removeClass("active");
//     	} else {
//     	    $(".contact-tabs .tabs .tab-wrapper").removeClass("active");
//             $(this).parents(".tab-wrapper").addClass("active");
//     	}
      
//     });
    
// } 

const contactAccordion = {
	accordBtn: document.querySelectorAll('.ContactPage .tab-top'),
	sideBarEl: document.querySelectorAll('.ContactPage .PageSidebar div>a'),
	contentInner: document.querySelectorAll('.ContactPage .tab-body'),
	container: document.querySelectorAll('.ContactPage .tab-wrapper'),
	footerLink: document.querySelectorAll('.Footer__Block--links .Link')
}

function accordionWithSidebar(obj) {
	obj.accordBtn.forEach(item => {
		
		item.addEventListener('click', function() {
			const content = document.getElementById(item.dataset.accordId);
			const buttonAccord = document.getElementById(item.dataset.accordButton);
			obj.accordBtn.forEach(el => {
				if (el != item) {
					el.classList.remove('active');
				}
			});
			obj.contentInner.forEach(el => {
				if (el != content) {
					el.classList.remove('active');	
				}
				
			});
			obj.sideBarEl.forEach(el => {
				if (el != buttonAccord) {
					el.classList.remove('active');		
				}
				
			});
			obj.container.forEach(el => {
				el.classList.remove('active');
			});
			this.classList.toggle('active');
			buttonAccord.classList.toggle('active');
			content.classList.toggle('active');
			
		});
		
		
	});

    
}

function sideBarAccordion(obj) {
	obj.sideBarEl.forEach(item => {
    	item.addEventListener('click', () => {
			const content = document.getElementById(item.dataset.accordId);
			const tabTop = document.querySelector('.' + item.dataset.tabTop);
			console.log();
			obj.accordBtn.forEach(el => {
				el.classList.remove('active');
			});
			obj.contentInner.forEach(el => {
				el.classList.remove('active');
			});
    		obj.sideBarEl.forEach(el => {
    			el.classList.remove('active');
    		});
    		obj.container.forEach(el => {
				el.classList.remove('active');
			})
    		item.classList.add('active');
    		content.classList.add('active');
    		tabTop.classList.add('active');

    	});
    	
    	
    });
}
function footerAccordion(obj) {
	// const contentWrapper = document.querySelector('.PageContentDropDown');
	console.log(window.location.hash);

	obj.accordBtn.forEach(item => {
		
		const itemId = '#' + item.id;
		if (window.location.hash === itemId) {
			const content = document.getElementById(item.dataset.accordId);
			const buttonAccord = document.getElementById(item.dataset.accordButton);
			item.classList.add('active');
			buttonAccord.classList.add('active');
			content.classList.add('active');
		}
	});
	
	obj.footerLink.forEach(item => {
		// console.log(item.innerText);
		item.addEventListener('click', function() {
			obj.sideBarEl.forEach(el => {

				if (item.innerText.split(' ').pop() === el.innerText.split(' ').pop()) {
					const content = document.getElementById(el.dataset.accordId);
					const tabTop = document.querySelector('.' + el.dataset.tabTop);
					// const buttonAccord = document.getElementById(el.dataset.accordButton);
					obj.sideBarEl.forEach(item => {
						item.classList.remove('active');
					});
					obj.accordBtn.forEach(el => {
						el.classList.remove('active');
					});
					obj.contentInner.forEach(el => {
						el.classList.remove('active');
					});
					obj.container.forEach(el => {
						el.classList.remove('active');
					})
					el.classList.add('active');
					content.classList.add('active');
					tabTop.classList.add('active');

				}
			})
		});
		
	})
}

function sustainability_tabs(){
	// $(".contact-tabs .tabs .tab-wrapper:nth-child(1) ").addClass("active");
    $(".sustainablility-page-container .tab-wrapper .tab-top ").click(function(){
    	if($(this).parents(".tab-wrapper").hasClass("active")){
          $(this).parents(".tab-wrapper").removeClass("active");
          $(this).parents(".tab-wrapper").find(".tab-body").slideUp();
    	} else {
    	    $(".contact-tabs .tabs .tab-wrapper").removeClass("active");
            $(this).parents(".tab-wrapper").addClass("active");
            $(this).parents(".tab-wrapper").find(".tab-body").slideDown();
    	}
      
    });
    $(".PageSidebar ul li a").click(function(){
       var href = $(this).attr("href").replace("#", "");
        $(".DropDown .contact-tabs .tab-wrapper").each(function(){
            var id = $(this).attr("id");
               
            if (id === href){       	
               $(this).addClass("active");
               $('html,body').animate({
			        scrollTop: $(this).offset().top - 80
			    }, 'slow');
            }  else {
            	$(this).removeClass("active");
            }
        });

    });
}   


function selectAddress() {
	if ($('body').hasClass('template-customers/addresses')) {
		$('#modal-address-new select[name="address[country]"]').val('Australia');
	}
}
const drawers = {
	// cart: document.getElementById('sidebar-cart'),
	// sidebarMenu: document.getElementById('sidebar-menu'),
	openCartBtn: document.querySelector('[data-action-click="open-cart"]'),
	closeCartBtn: document.querySelectorAll('[data-action-click="close-cart"]'),
	openSidebarBtn: document.querySelector('[data-action-click="open-menu"]'),
	closeSidebarBtn: document.querySelectorAll('[data-action-lick="close-menu"]'),
	searchBtn: document.querySelector('.hidden-tablet-and-up .Icon--search'),
	productForm: document.querySelector('.ProductForm__AddToCart'),
	drawerOpenCartBtn: document.querySelector('.SidebarMenu__sNav .Cart'),
	header: document.querySelector('.shopify-section--header'),


}
console.log(drawers.openCartBtn);

// console.log(drawers.cartBtn);

function Drawer(obj) {
		const cart = document.getElementById(obj.openCartBtn.dataset.idDrawer);
		const sideBar = document.getElementById(obj.openSidebarBtn.dataset.idDrawer);
		const body = document.querySelector('body');
		const mainWrapper = document.querySelector('html');

		obj.openCartBtn.addEventListener('click', function(event) {
          console.log('openCartBtn');
			event.preventDefault();
			obj.closeCartBtn.forEach(button => {
				button.style.display = "inline-block";
			});
			this.style.display = "none";
			cart.ariaHidden = 'false';
			if (sideBar.ariaHidden === 'false') {
				sideBar.ariaHidden = 'true';
			};
			obj.searchBtn.style.display = "none";
			body.style.height = '100vh';
			body.style.overflowY = 'hidden';

		});
		obj.closeCartBtn.forEach(button => {
			button.addEventListener('click', function(event) {
				
				cart.ariaHidden = 'true';
				obj.openCartBtn.style.display = "inline-block";
				this.style.display = "none";
				obj.searchBtn.style.display = "inline-block";
				body.style.height = 'auto';
				body.style.overflowY = 'visible';
				mainWrapper.classList.remove('no-scroll');
				obj.header.style.position = 'sticky';
			});
		});
		obj.openSidebarBtn.addEventListener('click', function(event) {
          console.log('openSidebarBtn');
			event.preventDefault();
			// obj.closeCartBtn.forEach(button => {
			// 	button.style.display = "inline-block";
			// });
			// this.style.display = "none";
			if (cart.ariaHidden === 'false') {
				cart.ariaHidden = 'true';
				obj.closeCartBtn.forEach(button => {
					button.style.display = "none";
				});
				obj.openCartBtn.style.display = "inline-block";
			};
			sideBar.ariaHidden = 'false';
			body.style.height = '100vh';
			body.style.overflowY = 'hidden';

		});
		obj.closeSidebarBtn.forEach(button => {
			button.addEventListener('click', function(event) {
				
				sideBar.ariaHidden = 'true';
				obj.openSidebarBtn.style.display = "inline-block";
				obj.searchBtn.style.display = "inline-block";
				body.style.height = 'auto';
				body.style.overflowY = 'visible';
				obj.header.style.position = 'sticky';
			});
		});
		if (obj.productForm) {
			obj.productForm.addEventListener('click', function() {
				obj.openCartBtn.style.display = "none";
				obj.closeCartBtn.forEach(button => {
					button.style.display = "inline-block";
				});
				cart.ariaHidden = 'false';
				obj.searchBtn.style.display = "none";
				
			});
		}
		
		console.log(obj.drawerOpenCartBtn);
		obj.drawerOpenCartBtn.addEventListener('click', function(event) {
          console.log('drawerOpenCartBtn');
			event.preventDefault();
			console.log('huiiii');
			obj.closeCartBtn.forEach(button => {
				button.style.display = "inline-block";
			});
			obj.openCartBtn.style.display = "none";
			cart.ariaHidden = 'false';
			sideBar.ariaHidden = 'true';
			obj.searchBtn.style.display = "none";
			body.style.height = '100vh';
			body.style.overflowY = 'hidden';
			obj.header.style.position = 'fixed';
		});


	

};

// setTimeout(function() {
// 	const afterPayEl = document.querySelector('.afterpay-paragraph');
// 	const afterPayWrapper = document.querySelector('.Afterpay');
// 	console.log(afterPayEl);
// 	afterPayWrapper.appendChild(afterPayEl);
// 	afterPayEl.style.marginTop = '20px';
// 	afterPayEl.style.cssText = 'display:block !important';
// }, 1000);


// setTimeout(function() {
// 	const captchaContainer = document.querySelector('.shopify-challenge__container');
// 	if (captchaContainer) {
// 		captchaContainer.style.paddingTop = "70px";
// 		captchaContainer.scrollIntoView(true);
// 	}
// }, 500);
